"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.scopeCSSVar = exports.getTransformedName = exports.get = exports.hooks = exports.diagnostics = void 0;
const feature_1 = require("./feature");
const STSymbol = __importStar(require("./st-symbol"));
const css_custom_property_1 = require("../helpers/css-custom-property");
const deprecation_1 = require("../helpers/deprecation");
const value_1 = require("../helpers/value");
const global_1 = require("../helpers/global");
const plugable_record_1 = require("../helpers/plugable-record");
// ToDo: refactor out - parse once and pass to hooks
const postcss_value_parser_1 = __importDefault(require("postcss-value-parser"));
exports.diagnostics = {
    ...css_custom_property_1.atPropertyValidationWarnings,
    ILLEGAL_CSS_VAR_USE(name) {
        return `a custom css property must begin with "--" (double-dash), but received "${name}"`;
    },
    ILLEGAL_CSS_VAR_ARGS(name) {
        return `custom property "${name}" usage (var()) must receive comma separated values`;
    },
    DEPRECATED_ST_GLOBAL_CUSTOM_PROPERTY() {
        return `"st-global-custom-property" is deprecated and will be removed in the next version. Use "@property" with ${global_1.GLOBAL_FUNC}`;
    },
    GLOBAL_CSS_VAR_MISSING_COMMA(name) {
        return `"@st-global-custom-property" received the value "${name}", but its values must be comma separated`;
    },
    ILLEGAL_GLOBAL_CSS_VAR(name) {
        return `"@st-global-custom-property" received the value "${name}", but it must begin with "--" (double-dash)`;
    },
    MISSING_PROP_NAME() {
        return `missing custom property name for "var(--[PROP NAME])"`;
    },
};
const dataKey = plugable_record_1.plugableRecord.key('custom-property');
// HOOKS
exports.hooks = (0, feature_1.createFeature)({
    metaInit({ meta }) {
        plugable_record_1.plugableRecord.set(meta.data, dataKey, { stCustomGlobalProperty: {} });
    },
    analyzeInit(context) {
        // ToDo: move to `STImport.ImportTypeHook`
        for (const [symbolName, symbol] of Object.entries(STSymbol.getAllByType(context.meta, `import`))) {
            if ((0, css_custom_property_1.validateCustomPropertyName)(symbolName)) {
                const importSymbol = STSymbol.get(context.meta, symbolName, `import`);
                if (!importSymbol) {
                    console.warn(`imported symbol "${symbolName}" not found on "${context.meta.source}"`);
                    continue;
                }
                addCSSProperty({
                    context,
                    node: symbol.import.rule,
                    name: symbolName,
                    global: false,
                    final: true,
                    alias: importSymbol,
                });
            }
        }
    },
    analyzeAtRule({ context, atRule }) {
        if (atRule.name === `property`) {
            let name = atRule.params;
            let global = false;
            // check global
            const globalVarName = (0, global_1.globalValue)(name);
            if (globalVarName !== undefined) {
                name = globalVarName.trim();
                global = true;
            }
            // handle conflict with deprecated `@st-global-custom-property`
            if (plugable_record_1.plugableRecord.getUnsafe(context.meta.data, dataKey).stCustomGlobalProperty[name]) {
                global = true;
            }
            addCSSProperty({
                context,
                node: atRule,
                name,
                global,
                final: true,
            });
            (0, css_custom_property_1.validateAtProperty)(atRule, context.diagnostics);
        }
        else if (atRule.name === `st-global-custom-property`) {
            analyzeDeprecatedStGlobalCustomProperty(context, atRule);
        }
    },
    analyzeDeclaration({ context, decl }) {
        // register prop
        if ((0, css_custom_property_1.validateCustomPropertyName)(decl.prop)) {
            addCSSProperty({
                context,
                node: decl,
                name: decl.prop,
                global: false,
                final: false,
            });
        }
        // register value
        if (decl.value.includes('var(')) {
            analyzeDeclValueVarCalls(context, decl);
        }
    },
    prepareAST({ node, toRemove }) {
        if (node.type === `atrule` && node.name === 'st-global-custom-property') {
            toRemove.push(node);
        }
    },
    transformResolve({ context: { meta, getResolvedSymbols } }) {
        const customPropsMapping = {};
        const resolvedSymbols = getResolvedSymbols(meta);
        for (const [localVarName, localSymbol] of Object.entries(STSymbol.getAllByType(meta, `cssVar`))) {
            const resolve = resolvedSymbols.cssVar[localVarName] || {
                // fallback to local namespace
                _kind: `css`,
                symbol: localSymbol,
                meta,
            };
            customPropsMapping[localVarName] = getTransformedName(resolve);
        }
        return customPropsMapping;
    },
    transformAtRuleNode({ atRule, resolved }) {
        var _a;
        if (atRule.name !== `property`) {
            return;
        }
        if ((_a = atRule.nodes) === null || _a === void 0 ? void 0 : _a.length) {
            if (resolved[atRule.params]) {
                atRule.params = resolved[atRule.params] || atRule.params;
            }
        }
        else {
            // remove `@property` with no body
            atRule.remove();
        }
    },
    transformDeclaration({ decl, resolved }) {
        decl.prop = resolved[decl.prop] || decl.prop;
    },
    transformValue({ node, data: { cssVarsMapping } }) {
        var _a;
        const { value } = node;
        const varWithPrefix = ((_a = node.nodes[0]) === null || _a === void 0 ? void 0 : _a.value) || ``;
        if ((0, css_custom_property_1.validateCustomPropertyName)(varWithPrefix)) {
            if (cssVarsMapping && cssVarsMapping[varWithPrefix]) {
                node.nodes[0].value = cssVarsMapping[varWithPrefix];
            }
        }
        // handle default values - ToDo: check if required
        if (node.nodes.length > 2) {
            node.resolvedValue = (0, value_1.stringifyFunction)(value, node);
        }
    },
    transformJSExports({ exports, resolved }) {
        for (const varName of Object.keys(resolved)) {
            exports.vars[varName.slice(2)] = resolved[varName];
        }
    },
});
// API
function get(meta, name) {
    return STSymbol.get(meta, name, `cssVar`);
}
exports.get = get;
function addCSSProperty({ context, node, name, global, final, alias, }) {
    // validate indent
    if (!(0, css_custom_property_1.validateCustomPropertyName)(name)) {
        context.diagnostics.warn(node, exports.diagnostics.ILLEGAL_CSS_VAR_USE(name), {
            word: name,
        });
        return;
    }
    // usages bailout: addition of weak definition reference `--x: var(--x)`
    if (!final && !!STSymbol.get(context.meta, name, `cssVar`)) {
        return;
    }
    // define symbol
    STSymbol.addSymbol({
        context,
        symbol: {
            _kind: 'cssVar',
            name: name,
            global,
            alias,
        },
        safeRedeclare: !final || !!alias,
        node,
    });
    // deprecated
    (0, deprecation_1.ignoreDeprecationWarn)(() => (context.meta.cssVars[name] = STSymbol.get(context.meta, name, `cssVar`)));
}
function analyzeDeclValueVarCalls(context, decl) {
    const parsed = (0, postcss_value_parser_1.default)(decl.value);
    parsed.walk((node) => {
        var _a;
        if (node.type === 'function' && node.value === 'var' && node.nodes) {
            const varName = node.nodes[0];
            if (!varName) {
                context.diagnostics.warn(decl, exports.diagnostics.MISSING_PROP_NAME());
                return;
            }
            if (!(0, value_1.validateAllowedNodesUntil)(node, 1)) {
                const args = postcss_value_parser_1.default.stringify(node.nodes);
                context.diagnostics.warn(decl, exports.diagnostics.ILLEGAL_CSS_VAR_ARGS(args), {
                    word: args,
                });
            }
            addCSSProperty({
                context,
                name: ((_a = postcss_value_parser_1.default.stringify(varName)) === null || _a === void 0 ? void 0 : _a.trim()) || ``,
                node: decl,
                global: false,
                final: false,
            });
        }
    });
}
function analyzeDeprecatedStGlobalCustomProperty(context, atRule) {
    // report deprecation
    context.diagnostics.info(atRule, exports.diagnostics.DEPRECATED_ST_GLOBAL_CUSTOM_PROPERTY());
    //
    const cssVarsByComma = atRule.params.split(',');
    const cssVarsBySpacing = atRule.params
        .trim()
        .split(/\s+/g)
        .filter((s) => s !== ',');
    if (cssVarsBySpacing.length > cssVarsByComma.length) {
        context.diagnostics.warn(atRule, exports.diagnostics.GLOBAL_CSS_VAR_MISSING_COMMA(atRule.params), {
            word: atRule.params,
        });
        return;
    }
    for (const entry of cssVarsByComma) {
        const name = entry.trim();
        if ((0, css_custom_property_1.validateCustomPropertyName)(name)) {
            // ToDo: change to modify global instead of override
            addCSSProperty({
                context,
                node: atRule,
                name,
                global: true,
                final: true,
            });
            // keep track of defined props through `@st-custom-global-property` in order
            // to not override the default with following `@property` definitions
            const { stCustomGlobalProperty } = plugable_record_1.plugableRecord.getUnsafe(context.meta.data, dataKey);
            stCustomGlobalProperty[name] = STSymbol.get(context.meta, name, `cssVar`);
        }
        else {
            context.diagnostics.warn(atRule, exports.diagnostics.ILLEGAL_GLOBAL_CSS_VAR(name), {
                word: name,
            });
        }
    }
}
function getTransformedName({ symbol, meta }) {
    return symbol.global ? symbol.name : (0, css_custom_property_1.generateScopedCSSVar)(meta.namespace, symbol.name.slice(2));
}
exports.getTransformedName = getTransformedName;
function scopeCSSVar(resolver, meta, symbolName) {
    const importedVar = resolver.deepResolve(STSymbol.get(meta, symbolName));
    if (importedVar &&
        importedVar._kind === 'css' &&
        importedVar.symbol &&
        importedVar.symbol._kind === 'cssVar') {
        importedVar;
        return getTransformedName(importedVar);
    }
    const cssVar = STSymbol.get(meta, symbolName, `cssVar`);
    return (cssVar === null || cssVar === void 0 ? void 0 : cssVar.global) ? symbolName : (0, css_custom_property_1.generateScopedCSSVar)(meta.namespace, symbolName.slice(2));
}
exports.scopeCSSVar = scopeCSSVar;
//# sourceMappingURL=css-custom-property.js.map